import { useDialog } from './use-dialog'
import { useToast } from './use-toast'
import { MESSAGES } from '_/views/budget-view-v2/utils/messages'

/**
 * Hook to show messages based on code.
 */
export const useMessage = () => {
  const { showToast } = useToast()
  const { showDialog, closeDialog } = useDialog()

  /**
   * Show message with proper implementation based on the code.
   *
   * @param {number} code - Message code (described in Refera's documentation)
   * @param {function} [onApproveCb] - Use callback if type is simple, dialog, question or info.
   */
  const showMessage = (code, onApproveCb = () => {}) => {
    const message = MESSAGES[code]

    if (!message) {
      throw new Error(`Message code does not exist: ${code}`)
    }

    if (['error', 'success', 'warning'].includes(message.type)) {
      showToast({ type: message.type, message: message.pt })
    } else if (['simple', 'dialog', 'question', 'info'].includes(message.type)) {
      let labelApprove = 'OK'
      let labelCancel = 'Cancelar'
      /** @type {() => {}} */
      let onCancel = null
      if (message.type === 'question') {
        labelApprove = 'Sim'
        labelCancel = 'Não'
        onCancel = () => {
          closeDialog()
        }
      }
      let messageType = message.type
      if (message.type !== 'warning') {
        messageType = 'info'
      }
      showDialog({
        type: messageType,
        subject: message.pt,
        labelApprove,
        labelCancel,
        onApprove: () => {
          closeDialog()
          onApproveCb()
        },
        onCancel,
      })
    } else {
      console.warn(`Tipo de mensagem desconhecido: ${message.type}`)
    }
  }

  return { showMessage }
}
